module.exports = __webpack_public_path__ + "public/media/img_profile_example.7e58438f.png";